<script setup>

  /**
   * 
   * Komponens: carousel slider megvalósítása a Swiper csomag segítségével
   * 
  */

  // get project's image storage (cloudfront) url:
  const runtimeConfig = useRuntimeConfig();
  const cloudFrontDomain = runtimeConfig.public.cloudfront.domain;
  const slideImagePath = '/public/images/sliderstb/';
  const slideImageUrl = ref(cloudFrontDomain + slideImagePath)

  const { slides } = defineProps(['slides'])

  // let loading = ref(true)
  // const onImgLoad = () => {
  //   loading.value = false
  // }

</script>

<template>
  <div class="w-full relative swiper-container carousel-container">
    <InfoBarMainPage :componentid="'e57baf5d-d86b-413a-acd9-c7232d79e988'" />
    <Swiper
      :slidesPerView="1"
      :modules="[SwiperAutoplay, SwiperController, SwiperNavigation, SwiperPagination]"
      :centeredSlides="true"
      :loop="true"
      :navigation="true" 
      :pagination="{
        clickable: true,
      }"
      :scrollbar="true"
    >
      <!-- 
      :lazy = "{
        loadPrevNext: true, // pre-loads the next image to avoid showing a loading placeholder if possible
        // loadPrevNextAmount: 2 //or, if you wish, preload the next 2 images
      }"
      virtual: {
        slides: (function() {
          var slides = [];
          for (var i = 0; i < 600; i += 1) {
            slides.push(
              '<img src="https://picsum.photos/600/600/?image=' +
                (i + 1) +
                '"/><p>' +
                (i + 1) +
                "</p>"
            );
          }
          return slides;
        })()
      }
      -->
      <!-- v-show="!loading" -->
      <SwiperSlide
        v-for="(slide, key) in slides"
        :key="key"
        class="flex align-middle justify-center max-h-min pb-6"
      >
        <div class="z-10">
          <a :href="slide.url" class="block">
            <img
              :src="slideImageUrl + slide.image.replace(/\.[^/.]+$/, '.jpg')"
              :key="key"
              class="shadow-lg"
              :id="slide.id"
              :alt="slide.description || ''"
              :title="slide.description || ''"
            />
            <h1
              v-if="slide.description && slide.description !== ''"
              class="shadow-md bg-boxbg-dark bg-opacity-25 px-5 py-2 lg:rounded-b-lg text-center text-lg hover:underline"
            >
              {{ slide.description }}
            </h1>
          </a>
        </div>
        <img 
          :src="slideImageUrl + slide.image.replace(/\.[^/.]+$/, '.jpg')"
          class="absolute top-0 left-0 right-0 bottom-0 blur z-0 opacity-25 object-fit overflow-hidden"
          style="vertical-align: middle"
          alt=""
          title=""
        />
      </SwiperSlide>
    </Swiper>
  </div>
</template>
